var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-wrapper scrollable", class: _vm.name + "-table" },
    [
      _c("div", { staticClass: "table-content" }, [
        _c("ul", { staticClass: "table-head" }, [
          _c("li", { staticClass: "row thead" }, [
            _c(
              "ul",
              _vm._l(_vm.columns, function (key) {
                return _c(
                  "li",
                  { key: key, staticClass: "column", class: key },
                  [
                    key === "uid"
                      ? _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title.analytics"))),
                        ])
                      : key === "admin"
                      ? _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title.permission"))),
                        ])
                      : _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title." + key))),
                        ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c(
          "ul",
          { staticClass: "table-body scrollable" },
          _vm._l(_vm.gridData, function (entry, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "row",
                class: [
                  {
                    story:
                      _vm.name === "overview" &&
                      entry.page &&
                      entry.page[0] &&
                      entry.page[0].story,
                    "direct-removed":
                      entry.page &&
                      entry.page[0] &&
                      entry.page[0].insightsError,
                  },
                ],
                attrs: {
                  "data-qa":
                    _vm.name === "custom-sources"
                      ? `list-sources-${entry.name}`
                      : "",
                },
              },
              [
                _c(
                  "Tooltip",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      active:
                        _vm.name === "overview" &&
                        entry.page &&
                        entry.page.length &&
                        !!entry.page[0].insightsError,
                      text: _vm.$t(`dash.insights.direct-removed`),
                      position: "top",
                    },
                  },
                  [
                    _c(
                      "ul",
                      _vm._l(_vm.columns, function (key) {
                        return _c(
                          "li",
                          { key: key, staticClass: "column", class: key },
                          [
                            key === "pages" && _vm.name === "custom-sources"
                              ? _c(
                                  "ul",
                                  [
                                    _vm._l(entry.pages, function (bot, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          class: [
                                            {
                                              hide: !_vm.checkUserPageAccess(
                                                bot.page.id
                                              ),
                                            },
                                          ],
                                          on: {
                                            click: function ($event) {
                                              return _vm.goToBot(bot.id)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: bot.page.name,
                                                position: "top",
                                              },
                                            },
                                            [
                                              _c("page-image-avatar", {
                                                attrs: { page: bot.page },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "add",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openUpdateBots(entry)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.sources.affected-to-pages"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add_circle_outline")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            key === "pages" && _vm.name === "users"
                              ? _c(
                                  "ul",
                                  [
                                    _vm._l(
                                      entry.pages_access.slice(0, 3),
                                      function (page, index) {
                                        return _c(
                                          "li",
                                          { key: index },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: page.name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("page-image-avatar", {
                                                  attrs: { page: page },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    _c(
                                      "li",
                                      {
                                        staticClass: "add",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openUpdatePagesAccess(
                                              entry
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.user.add-pages-access"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add_circle_outline")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  2
                                )
                              : key === "pages" && _vm.name !== "overview"
                              ? _c(
                                  "div",
                                  [
                                    entry._bots && entry._bots[0]
                                      ? _c("page-image-avatar", {
                                          attrs: { page: entry._bots[0].page },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : key === "pages" && _vm.name === "overview"
                              ? _c(
                                  "div",
                                  [
                                    entry._bots &&
                                    entry._bots.find(
                                      (b) =>
                                        entry.page[0].id &&
                                        b.uid == entry.page[0].id
                                    )
                                      ? _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: entry._bots.find(
                                                (b) =>
                                                  entry.page[0].id &&
                                                  b.uid == entry.page[0].id
                                              ).page.name,
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c("page-image-avatar", {
                                              attrs: {
                                                page: entry._bots.find(
                                                  (b) =>
                                                    entry.page[0].id &&
                                                    b.uid == entry.page[0].id
                                                ).page,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : key === "source"
                              ? _c("div", { staticClass: "cell" }, [
                                  entry.flux &&
                                  entry.flux.source &&
                                  entry.flux.source.name
                                    ? _c("p", [
                                        _vm._v(_vm._s(entry.flux.source.name)),
                                      ])
                                    : _vm.sources &&
                                      _vm.sources.find(
                                        (s) =>
                                          entry.flux && s.uid == entry.flux.id
                                      )
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "column source",
                                          attrs: {
                                            data: _vm.sources.find(
                                              (s) =>
                                                entry.flux &&
                                                s.uid == entry.flux.id
                                            ).name,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.sources.find(
                                                  (s) =>
                                                    entry.flux &&
                                                    s.uid == entry.flux.id
                                                ).name
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "p",
                                        {
                                          staticClass: "column source",
                                          attrs: { data: "Custom" },
                                        },
                                        [_vm._v("Custom")]
                                      ),
                                ])
                              : key === "when" && entry.page && entry.page[0]
                              ? _c("div", { staticClass: "cell" }, [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(
                                          entry.page[0].posted_date
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : key === "type-source" &&
                                _vm.name === "custom-sources"
                              ? _c("div", [
                                  _c("p", { staticClass: "txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `dash.sources.${
                                            entry.type || "rss"
                                          }-source`
                                        )
                                      )
                                    ),
                                  ]),
                                ])
                              : key === "content-source" &&
                                _vm.name === "custom-sources"
                              ? _c("div", [
                                  !entry.type || entry.type == "rss"
                                    ? _c("p", { staticClass: "txt" }, [
                                        _vm._v(_vm._s(entry.url)),
                                      ])
                                    : _c("p", { staticClass: "txt" }, [
                                        _vm._v(_vm._s(entry.custom_field)),
                                      ]),
                                ])
                              : key === "content" && _vm.name !== "overview"
                              ? _c("div", { staticClass: "cell" }, [
                                  _c("div", { staticClass: "thumb-wrapper" }, [
                                    _c("img", {
                                      staticClass: "thumb",
                                      attrs: { src: entry[key].img },
                                    }),
                                  ]),
                                  _c("div", { staticClass: "txt-wrapper" }, [
                                    _c("p", [_vm._v(_vm._s(entry[key].txt))]),
                                  ]),
                                ])
                              : key === "content" && _vm.name === "overview"
                              ? _c("div", { staticClass: "cell" }, [
                                  _c("div", { staticClass: "thumb-wrapper" }, [
                                    entry.page[0].network == "instagram" &&
                                    entry.page[0].story &&
                                    _vm.getScreenshot(entry)
                                      ? _c("img", {
                                          staticClass: "thumb",
                                          attrs: {
                                            src: _vm.getScreenshot(entry),
                                          },
                                          on: { error: _vm.replaceByDefault },
                                        })
                                      : entry._bots.find(
                                          (b) =>
                                            entry.page[0].id &&
                                            b.uid == entry.page[0].id
                                        ).mode === "story" &&
                                        (entry.screenshot ||
                                          entry.page[0].enclosure)
                                      ? _c("img", {
                                          staticClass: "thumb",
                                          attrs: {
                                            src:
                                              entry.screenshot ||
                                              entry.page[0].enclosure,
                                          },
                                          on: { error: _vm.replaceByDefault },
                                        })
                                      : entry.enclosure != null &&
                                        entry.enclosure != ""
                                      ? _c("img", {
                                          staticClass: "thumb",
                                          attrs: { src: entry.enclosure },
                                          on: { error: _vm.replaceByDefault },
                                        })
                                      : entry.page &&
                                        entry.page[0] &&
                                        entry.page[0].video
                                      ? _c("video", {
                                          attrs: { src: entry.page[0].video },
                                        })
                                      : _c("img", {
                                          ref: `meta-image-${entry.id}`,
                                          refInFor: true,
                                          staticClass: "thumb",
                                          attrs: {
                                            meta: _vm.getMetaOgImage(
                                              entry,
                                              `meta-image-${entry.id}`,
                                              index
                                            ),
                                          },
                                          on: { error: _vm.replaceByDefault },
                                        }),
                                  ]),
                                  _c("div", { staticClass: "txt-wrapper" }, [
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.getText(entry)),
                                      },
                                    }),
                                  ]),
                                ])
                              : key === "stats"
                              ? _c("div", [
                                  entry.page &&
                                  entry.page[0] &&
                                  entry.page[0].insights &&
                                  entry.page[0].insights.length &&
                                  entry.page[0].network == "facebook" &&
                                  !entry._bots.find(
                                    (b) =>
                                      entry.page[0].id &&
                                      b.uid == entry.page[0].id
                                  ).page.isGroup
                                    ? _c("ul", { staticClass: "sources" }, [
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: entry.page[0].insights.find(
                                                    (i) =>
                                                      [
                                                        "fb_reels_total_plays",
                                                      ].includes(i.name)
                                                  )
                                                    ? _vm.$t(
                                                        "dash.reporting.total_read"
                                                      )
                                                    : _vm.$t(
                                                        "dash.reporting.impression"
                                                      ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_vues.svg"),
                                                    alt: "vues",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights.find(
                                                        (i) =>
                                                          [
                                                            "post_media_view",
                                                            "total_video_impressions",
                                                            "fb_reels_total_plays",
                                                            "total_video_impressions",
                                                          ].includes(i.name)
                                                      ).values[0].value
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.reaction"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_likes.svg"),
                                                    alt: "likes",
                                                  },
                                                }),
                                                entry.page[0].insights.find(
                                                  (i) =>
                                                    [
                                                      "post_reactions_like_total",
                                                      "total_video_reactions_by_type_total",
                                                    ].includes(i.name)
                                                )
                                                  ? _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].video
                                                            ? _vm.sumReaction(
                                                                entry.page[0].insights.find(
                                                                  (i) =>
                                                                    [
                                                                      "post_reactions_like_total",
                                                                      "total_video_reactions_by_type_total",
                                                                    ].includes(
                                                                      i.name
                                                                    )
                                                                ).values[0]
                                                                  .value
                                                              )
                                                            : entry.page[0].insights.find(
                                                                (i) =>
                                                                  [
                                                                    "post_reactions_like_total",
                                                                    "total_video_reactions_by_type_total",
                                                                  ].includes(
                                                                    i.name
                                                                  )
                                                              ).values[0].value
                                                        )
                                                      ),
                                                    ])
                                                  : entry.page[0].insights.find(
                                                      (i) =>
                                                        [
                                                          "post_video_likes_by_reaction_type",
                                                        ].includes(i.name)
                                                    )
                                                  ? _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.sumReaction(
                                                            entry.page[0].insights.find(
                                                              (i) =>
                                                                [
                                                                  "post_video_likes_by_reaction_type",
                                                                ].includes(
                                                                  i.name
                                                                )
                                                            ).values[0].value
                                                          ) || 0
                                                        )
                                                      ),
                                                    ])
                                                  : _c("p", [_vm._v("0")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: entry.page[0].insights.find(
                                                    (i) =>
                                                      [
                                                        "post_video_social_actions",
                                                      ].includes(i.name)
                                                  )
                                                    ? _vm.$t(
                                                        "dash.reporting.pdf.comments"
                                                      )
                                                    : _vm.$t(
                                                        "dash.reporting.clic"
                                                      ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                entry.page[0].insights.find(
                                                  (i) =>
                                                    [
                                                      "post_video_social_actions",
                                                    ].includes(i.name)
                                                )
                                                  ? _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_comments.svg"),
                                                        alt: "comments",
                                                      },
                                                    })
                                                  : _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_clicks.svg"),
                                                        alt: "clicks",
                                                      },
                                                    }),
                                                entry.page[0].insights.find(
                                                  (i) =>
                                                    [
                                                      "post_clicks",
                                                      "total_video_views_clicked_to_play",
                                                      "total_video_views_clicked_to_play",
                                                    ].includes(i.name)
                                                )
                                                  ? _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "post_clicks",
                                                                "total_video_views_clicked_to_play",
                                                                "total_video_views_clicked_to_play",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ])
                                                  : entry.page[0].insights.find(
                                                      (i) =>
                                                        [
                                                          "post_video_social_actions",
                                                        ].includes(i.name)
                                                    )
                                                  ? _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "post_video_social_actions",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                            .COMMENT
                                                        )
                                                      ),
                                                    ])
                                                  : _c("p", [_vm._v("0")]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large show",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPost(entry)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.posts.view")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : entry.page &&
                                      entry.page[0] &&
                                      entry.page[0].insights &&
                                      entry.page[0].insights.length &&
                                      entry.page[0].network == "instagram" &&
                                      !entry._bots.find(
                                        (b) =>
                                          entry.page[0].id &&
                                          b.uid == entry.page[0].id
                                      ).page.isGroup
                                    ? _c("ul", { staticClass: "sources" }, [
                                        entry.page[0].insights.find((i) =>
                                          ["views"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.impression"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_vues.svg"),
                                                        alt: "vues",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "views",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights.find((i) =>
                                          ["likes"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.reaction"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_likes.svg"),
                                                        alt: "likes",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "likes",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights.find((i) =>
                                          ["comments"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.pdf.comments"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_comments.svg"),
                                                        alt: "comments",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "comments",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights.find((i) =>
                                          ["shares"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.pdf.shares"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "icon-white shares",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_shares.svg"),
                                                        alt: "shares",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "shares",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights.find((i) =>
                                          ["saved"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.pdf.saved"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "icon-white saved",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_saved.svg"),
                                                        alt: "saved",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights.find(
                                                            (i) =>
                                                              [
                                                                "saved",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights &&
                                        entry.page[0].insights[0] &&
                                        entry.page[0].insights[0].insights &&
                                        entry.page[0].insights[0].insights
                                          .data &&
                                        entry.page[0].insights[0].insights.data.find(
                                          (i) => ["views"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.impression"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_vues.svg"),
                                                        alt: "views",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights[0].insights.data.find(
                                                            (i) =>
                                                              [
                                                                "views",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights &&
                                        entry.page[0].insights[0] &&
                                        entry.page[0].insights[0].insights &&
                                        entry.page[0].insights[0].insights
                                          .data &&
                                        entry.page[0].insights[0].insights.data.find(
                                          (i) => ["replies"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.replies"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_comments.svg"),
                                                        alt: "replies",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights[0].insights.data.find(
                                                            (i) =>
                                                              [
                                                                "replies",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights &&
                                        entry.page[0].insights[0] &&
                                        entry.page[0].insights[0].insights &&
                                        entry.page[0].insights[0].insights
                                          .data &&
                                        entry.page[0].insights[0].insights.data.find(
                                          (i) => ["shares"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.pdf.shares"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "icon-white shares",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_shares.svg"),
                                                        alt: "shares",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights[0].insights.data.find(
                                                            (i) =>
                                                              [
                                                                "shares",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights &&
                                        entry.page[0].insights[0] &&
                                        entry.page[0].insights[0].insights &&
                                        entry.page[0].insights[0].insights
                                          .data &&
                                        entry.page[0].insights[0].insights.data.find(
                                          (i) => ["follows"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.follows"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_likes.svg"),
                                                        alt: "follows",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights[0].insights.data.find(
                                                            (i) =>
                                                              [
                                                                "follows",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        entry.page[0].insights &&
                                        entry.page[0].insights[0] &&
                                        entry.page[0].insights[0].insights &&
                                        entry.page[0].insights[0].insights
                                          .data &&
                                        entry.page[0].insights[0].insights.data.find(
                                          (i) => ["navigation"].includes(i.name)
                                        )
                                          ? _c(
                                              "li",
                                              [
                                                _c(
                                                  "Tooltip",
                                                  {
                                                    attrs: {
                                                      text: _vm.$t(
                                                        "dash.reporting.navigation"
                                                      ),
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticClass: "icon-white",
                                                      attrs: {
                                                        src: require("../../assets/img/rss/icon_clicks.svg"),
                                                        alt: "navigation",
                                                      },
                                                    }),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.page[0].insights[0].insights.data.find(
                                                            (i) =>
                                                              [
                                                                "navigation",
                                                              ].includes(i.name)
                                                          ).values[0].value
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large show",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPost(entry)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.posts.view")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : entry.page &&
                                      entry.page[0] &&
                                      entry.page[0].insights &&
                                      entry.page[0].network == "twitter"
                                    ? _c("ul", { staticClass: "sources" }, [
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.impression"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_vues.svg"),
                                                    alt: "vues",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .impression_count
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.posts.retweet"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_retweet.svg"),
                                                    alt: "retweet",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .retweet_count
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.reaction"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_likes.svg"),
                                                    alt: "likes",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .like_count
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.pdf.comments"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_comments.svg"),
                                                    alt: "comments",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .reply_count
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large show",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPost(entry)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.posts.view")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : entry.page &&
                                      entry.page[0] &&
                                      entry.page[0].insights &&
                                      entry.page[0].network == "linkedin"
                                    ? _c("ul", { staticClass: "sources" }, [
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.impression"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_vues.svg"),
                                                    alt: "vues",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .totalShareStatistics
                                                        .impressionCount
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.reaction"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_likes.svg"),
                                                    alt: "likes",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .totalShareStatistics
                                                        .likeCount
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.pdf.comments"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_comments.svg"),
                                                    alt: "comments",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .totalShareStatistics
                                                        .commentCount
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.pdf.shares"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "icon-white shares",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_shares.svg"),
                                                    alt: "shares",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .totalShareStatistics
                                                        .shareCount
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "dash.reporting.clic"
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "icon-white",
                                                  attrs: {
                                                    src: require("../../assets/img/rss/icon_clicks.svg"),
                                                    alt: "clicks",
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      entry.page[0].insights
                                                        .totalShareStatistics
                                                        .clickCount
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "li",
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large show",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPost(entry)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.posts.view")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : entry.page &&
                                      entry.page[0] &&
                                      [
                                        "facebook",
                                        "linkedin",
                                        "twitter",
                                        "instagram",
                                      ].includes(entry.page[0].network)
                                    ? _c("ul", { staticClass: "sources" }, [
                                        entry.page[0].insightsError ||
                                        (entry.page[0].insights &&
                                          entry.page[0].insights.length == 0)
                                          ? _c("li", [_c("p", [_vm._v("N/A")])])
                                          : _c(
                                              "li",
                                              {
                                                staticClass: "insights-loading",
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("sync")]
                                                ),
                                              ]
                                            ),
                                        entry.page[0].insightsError
                                          ? _c(
                                              "li",
                                              { staticClass: "absolute-right" },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "btn-large show",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showPost(
                                                          entry
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "dash.posts.view"
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "li",
                                              { staticClass: "absolute-right" },
                                              [
                                                _c(
                                                  "vs-button",
                                                  {
                                                    staticClass:
                                                      "btn-large show",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.showPost(
                                                          entry
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "dash.posts.view"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                      ])
                                    : entry.page &&
                                      entry.page[0] &&
                                      [
                                        "threads",
                                        "bluesky",
                                        "pinterest",
                                        "google",
                                        "youtube",
                                      ].includes(entry.page[0].network)
                                    ? _c("ul", { staticClass: "sources" }, [
                                        _c(
                                          "li",
                                          { staticClass: "absolute-right" },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "btn-large show",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showPost(entry)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("dash.posts.view")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ])
                              : key === "status"
                              ? _c("div", [
                                  _vm.name === "custom-sources"
                                    ? _c(
                                        "p",
                                        { staticClass: "sources-status" },
                                        [
                                          entry.status
                                            ? [
                                                _c("vs-avatar", {
                                                  attrs: {
                                                    color: "transparent",
                                                    size: "18px",
                                                    src: require("../../assets/img/icon_check_light.svg"),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.findNewsParsed(
                                                        entry
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("span", [_vm._v(" ")]),
                                                _c(
                                                  "span",
                                                  { staticClass: "ok" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        `${
                                                          !entry.to_fetch_at
                                                            ? _vm.$t(
                                                                "dash.sources.status_running"
                                                              )
                                                            : `${_vm.$t(
                                                                "dash.sources.to_fetch_at"
                                                              )} ${_vm.formatDate(
                                                                entry.to_fetch_at
                                                              )}`
                                                        }`
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : [
                                                _c("vs-avatar", {
                                                  attrs: {
                                                    color: "transparent",
                                                    size: "18px",
                                                    src: require("../../assets/img/icon_stop.svg"),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.confirmEnable(
                                                        entry.id
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("a", {
                                                  attrs: { href: "#" },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "dash.sources.enable"
                                                      )
                                                    ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.confirmEnable(
                                                        entry.id
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      `${_vm.$t(
                                                        "dash.sources.status_error"
                                                      )} : ${entry.error}`
                                                    )
                                                  ),
                                                ]),
                                              ],
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ])
                              : key === "actions"
                              ? _c(
                                  "div",
                                  [
                                    _vm.name === "invoice"
                                      ? _c(
                                          "vs-button",
                                          {
                                            attrs: {
                                              color: "#a9a9a9",
                                              "vs-type": "border",
                                              size: "large",
                                              type: "submit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.download(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.button.download")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.name === "users" || _vm.name === "bots"
                                      ? _c(
                                          "vs-button",
                                          {
                                            attrs: {
                                              color: "#a9a9a9",
                                              "vs-type": "border",
                                              size: "large",
                                              type: "submit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.edit(entry.id)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("dash.button.edit"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    (_vm.name === "users" &&
                                      (!entry.admin ||
                                        _vm.gridData.filter((e) => e && e.admin)
                                          .length > 1)) ||
                                    _vm.name === "custom-sources"
                                      ? _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                `dash.button.delete`
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "delete-btn",
                                                attrs: {
                                                  size: "large",
                                                  type: "submit",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.remove(entry.id)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("close")]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.name === "suggested-sources"
                                      ? _c(
                                          "vs-button",
                                          {
                                            attrs: {
                                              color: "#a9a9a9",
                                              "vs-type": "border",
                                              size: "large",
                                              type: "submit",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.remove(index)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("dash.button.botremove")
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : key === "admin"
                              ? _c("div", [
                                  _c("p", { staticClass: "txt" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          `dash.settings.user.${_vm.getUserRole(
                                            entry
                                          )}`
                                        )
                                      ) + "\n                  "
                                    ),
                                    _vm.getUserRole(entry) == "Viewer"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getViewerLoginUrl(
                                                  entry.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    `dash.settings.user.viewer.url`
                                                  )
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _vm.name === "custom-sources" &&
                                    key == "name"
                                      ? [
                                          _c(
                                            "Tooltip",
                                            {
                                              attrs: {
                                                text: _vm.$t(
                                                  `dash.sources.${
                                                    entry.type || "rss"
                                                  }-source`
                                                ),
                                                position: "top",
                                              },
                                            },
                                            [
                                              !entry.type || entry.type == "rss"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/rss-source.svg"),
                                                      alt: "rss",
                                                    },
                                                  })
                                                : entry.type == "google-news"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/google-news-source.svg"),
                                                      alt: "google-news",
                                                    },
                                                  })
                                                : entry.type == "youtube"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/logo-youtube.svg"),
                                                      alt: "youtube-source",
                                                    },
                                                  })
                                                : entry.type == "vimeo"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/vimeo-source.svg"),
                                                      alt: "vimeo-source",
                                                    },
                                                  })
                                                : entry.type == "dailymotion"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/dailymotion-source.svg"),
                                                      alt: "dailymotion-source",
                                                    },
                                                  })
                                                : entry.type == "pinterest"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/pinterest-source.svg"),
                                                      alt: "pinterest-source",
                                                    },
                                                  })
                                                : entry.type == "twitter"
                                                ? _c("img", {
                                                    attrs: {
                                                      src: require("../../assets/img/twitter-source.svg"),
                                                      alt: "twitter-source",
                                                    },
                                                  })
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass: "txt link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.edit(entry.id)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(entry[key]) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _c("p", { staticClass: "txt" }, [
                                          _vm._v(_vm._s(entry[key])),
                                        ]),
                                  ],
                                  2
                                ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c(
        "vs-popup",
        {
          class: `sidebar-action list-news`,
          attrs: {
            title: _vm.$t("dash.sources.to_fetch_at"),
            active: _vm.showListNews,
          },
          on: {
            "update:active": function ($event) {
              _vm.showListNews = $event
            },
          },
        },
        [
          _c(
            "ul",
            _vm._l(_vm.listNews, function (news, index) {
              return _c("li", { key: index }, [
                _c("a", { attrs: { href: news.url, target: "_blank" } }, [
                  _c("div", { staticClass: "wrapper" }, [
                    news.enclosure
                      ? _c("img", { attrs: { src: news.enclosure } })
                      : _vm._e(),
                  ]),
                  _c("p", [
                    _c("span", { staticClass: "date" }, [
                      _vm._v(_vm._s(_vm.formatDate(news.published_at))),
                    ]),
                    _vm._v(
                      "\n            " + _vm._s(news.title) + "\n          "
                    ),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }